<div class="payment-status-screen">
    <div class="img-container">
        <img src='assets/images/taly-dark-icon.svg'>
    </div>
    <div class="img-container-loader">
        <ng-container *ngIf="message == 'Processing' ; else cardStatus">
            <img [src]="'assets/images/loader-icon.gif'">
        </ng-container>
        <ng-template #cardStatus>
            <img [src]="isSuccess ?  'assets/images/payment-success.svg' : 'assets/images/reject-logo.svg'">
          </ng-template>
       
    </div>
    <div class="section-title" >
        <h4>{{message  == 'Processing' ? ('Processing' | translate) : message }}</h4>
    </div>
</div>